import React, { useCallback, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { InputFormGroup, LineByLineFormGroup } from '@bingads-webui-cc-react/layout';
import { Select } from '@bingads-webui-react/primitive-validation';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { DeclineReasonTypesI18nMapping } from '../constants';
import { useValidationI18n } from '../hooks/use-i18n';

const { TaxCertificateDeclineReasonType } = Constants;

const DeclineReasonTypeSchema = {
  properties: {
    declineReasonType: {
      type: 'number',
      required: true,
    },
  },
};

export const TaxCertificateDeclineReasonTypeDropdown = ({
  i18n,
  selectedDeclineReasonType,
  onDeclineReasonTypeChange,
  showLineByLineFormGroup,
  alwaysShowError,
  disabled,
}) => {
  const validationI18n = useValidationI18n(i18n);
  const CustomizedFormGroup = showLineByLineFormGroup ? LineByLineFormGroup : InputFormGroup;

  const onDeclineReasonTypeValidate = useCallback(({ data, isValid }) => {
    onDeclineReasonTypeChange({
      declineReasonType: data.declineReasonType,
      isValid,
    });
  }, [onDeclineReasonTypeChange]);

  // Clear data when unmount
  // useLayoutEffect to make sure it runs before the next component's effect
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useLayoutEffect(() => () => onDeclineReasonTypeChange({ declineReasonType: null, isValid: true }), []);

  return (
    <CustomizedFormGroup
      isStatic
      label={i18n.getString(_TL_('Rejection reason'))}
      className="tax-cert-decline-reason-type-dropdown"
    >
      <Select
        id="decline-reason-type-select"
        disabled={disabled}
        validationProps={{
          i18n: validationI18n,
          alwaysShowError,
          onValidate: onDeclineReasonTypeValidate,
          field: 'declineReasonType',
          data: { declineReasonType: DeclineReasonTypesI18nMapping[selectedDeclineReasonType] && selectedDeclineReasonType && selectedDeclineReasonType.toString() },
          schema: DeclineReasonTypeSchema,
        }}
      >
        <option key="" value="">{i18n.getString(_TL_('(Not set)'))}</option>
        {
          _.map(TaxCertificateDeclineReasonType, value => (<option key={value} value={value}>{i18n.getString(DeclineReasonTypesI18nMapping[value])}</option>))
        }
      </Select>
    </CustomizedFormGroup>
  );
};

TaxCertificateDeclineReasonTypeDropdown.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  onDeclineReasonTypeChange: PropTypes.func.isRequired,
  selectedDeclineReasonType: PropTypes.number,
  showLineByLineFormGroup: PropTypes.bool,
  alwaysShowError: PropTypes.bool,
  disabled: PropTypes.bool,
};

TaxCertificateDeclineReasonTypeDropdown.defaultProps = {
  selectedDeclineReasonType: null,
  showLineByLineFormGroup: false,
  alwaysShowError: false,
  disabled: false,
};
